import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserProfile } from '../../models/user-profile.model';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { Storage } from '@ionic/storage';
import { RecalculateSummarySalesService } from './recalculate-summary-sales.service';

@Component({
  selector: 'app-recalculate-summary-sales',
  templateUrl: './recalculate-summary-sales.page.html',
  styleUrls: ['./recalculate-summary-sales.page.scss'],
})
export class RecalculateSummarySalesPage implements OnInit {

  counterList: any[] = [];
  formRecalculateSummarySales: FormGroup = new FormGroup({});
  year: any;
  month: any;
  monthName: any;
  userProfile: UserProfile = new UserProfile();
  token: any;

  counterId:number=0;
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private fb: FormBuilder,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private recalculateSummarySalesService: RecalculateSummarySalesService
  ) { }

  ngOnInit() {
    let todayDate = new Date();
    let convertDate = this.utilService.convertDate(todayDate);
    this.month = convertDate.months;
    this.buildRecalculateStockForm();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.getActiveCounter();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildRecalculateStockForm() {
    this.formRecalculateSummarySales = this.fb.group({
      transDate: [],
      counterId: []
    });
  }
  
  getActiveCounter() {
    let options = {
      "token": this.token,
      "counter_id": this.userProfile.counter_id_pos !== 0 ? this.userProfile.counter_id_pos : this.userProfile.counter_id_list
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.recalculateSummarySalesService.getActiveCounter(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.code === 200) {
          this.counterList = response.data;
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  recalculate() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const recalculateStock = this.formRecalculateSummarySales.getRawValue();
      let dateConvert = this.utilService.convertDate(recalculateStock.transDate);
      this.year = dateConvert.years;
      this.month = dateConvert.months;
      let body = {
        counter_id: this.counterId,
        year: this.year,
        month: this.month
      };
      
      this.recalculateSummarySalesService.recalculateSummarySales(body).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.toastCtrl.create({ duration: 2000, message: 'Sukses' }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  selectCounter(event:any){
    this.counterId = event.value.id;
  }

}
